<script setup lang="ts">
import {useRouter} from "vue-router";
import BaseButton from "@/core/components/base/BaseButton.vue";
const router = useRouter();

/**
 * Open the feature highlight replay page.
 */
const openReplay = () => {
    router.push({name: 'feature-highlights'});
};
</script>

<template>
  <div class="bg-white rounded-lg p-4">
    <div class="flex flex-row justify-between">
      <div class="flex flex-col">
        <div class="flex flex-row items-center gap-2">
          <div class="bg-primary/15 py-1 px-3 rounded-full">
            <span class="text-primary">VENDREDI EXPERT 🚀</span>
          </div>
          <p class="text-primary text-sm">
            Chaque semaine, un sujet Apodis
          </p>
        </div>
        <div class="flex flex-col py-2">
          <h2 class="text-xl font-semibold">
            Les Vendredis Experts font une pause estivale 🏖️

            Retrouvez-nous à la rentrée avec de nouvelles thématiques et plein de nouveautés. En attendant, profitez de l’été pour découvrir ou redécouvrir nos replays !
          </h2>
          <!--h2>Aucun sujet planifié pour cette semaine, consultez les replays pour voir les précédentes sessions</h2-->
        </div>
      </div>
      <div class="flex flex-col items-end justify-end">
        <div class="flex">
          <BaseButton primary @click="openReplay">
            Voir les replays >
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>
